import { render, staticRenderFns } from "./ParticipantsMoodleActivityCertificatesGrid.vue?vue&type=template&id=16120e10"
import script from "./ParticipantsMoodleActivityCertificatesGrid.vue?vue&type=script&lang=js"
export * from "./ParticipantsMoodleActivityCertificatesGrid.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsMoodleActivityCertificatesGrid.vue?vue&type=style&index=0&id=16120e10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports